/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Modification } from './modification';
import { PriceCalculationKind } from './priceCalculationKind';
import { SalesProduct } from './salesProduct';

/**
 * This is a set of prices, combined with a detailed description how the price caclulation was done.   The *salesProduct* property has an identical structure compared with the input data,  but it contains only prices and few relevant properties.
 */
export interface PriceCalculation {
  kind: PriceCalculationKind;
  /**
   * This defines a set of special price calculations. These calculations are agent specific.   Example: *Rabattstaffel_15*, *CALC_TEI_AND_VOL*
   */
  additionalKind?: string;
  /**
   * Set of modifications compared to the original input request data.  Example 1: Prices for package *Classic* |modificationKind|value  | |----------------|-------| |PACKAGE_MODIFIED|Classic|  Example 2: Package *Premium* and removed incentive code |modificationKind       |value  | |-----------------------|-------| |PACKAGE_MODIFIED       |Premium| |INCENTIVE_CODE_REMOVED |       |  Example 3: Package *Premium* and incentive code added (part of Rabattstaffel)  |modificationKind       |value     | |-----------------------|-------   | |PACKAGE_MODIFIED       |Premium   | |INCENTIVE_CODE_ADDED   |RABATT0005|
   */
  modifications: Array<Modification>;
  salesProduct: SalesProduct;
}
export namespace PriceCalculation {}
